/* import __COLOCATED_TEMPLATE__ from './fin-workflows-illustration.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const FinWorkflowsIllustration = templateOnlyComponent<Signature>();

export default FinWorkflowsIllustration;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::FinWorkflowsIllustration': typeof FinWorkflowsIllustration;
  }
}
